export enum QueryOperation {
  Equal = 0,

  NotEqual = 1,
  LessThan = 2,
  LessThanOrEqual = 3,
  GreaterThan = 4,
  GreaterThanOrEqual = 5,
  Contains = 6,
  NotContains = 7,
  StartsWith = 8,
  NotStartsWith = 9,
  EndsWith = 10,
  NotEndsWith = 11,

  Between = 12,
  NotBetween = 13,

  Sub = 14,

  // Set membership (SQL IN) — the values list is OR-ed on a single field
  In = 15,
  NotIn = 16,
}

export enum QueryCase {
  Default = 0,
  Lower = 1,
  Upper = 2,
}

// How a SearchQuery's own conditions + nested groups combine.
export enum ConditionLogic {
  And = 0,
  Or = 1,
}

export interface QueryCondition {
  readonly field: string;
  readonly operation: QueryOperation;
  readonly values: (string | number | boolean)[];
  readonly case?: QueryCase;
}

// A node in a boolean condition tree: its `conditions` (leaves) and nested `groups` (sub-trees) are
// all combined with `logic` (default And). Nest groups with mixed logic to build arbitrary AND/OR clauses.
export interface SearchQuery {
  readonly conditions: QueryCondition[];
  readonly logic?: ConditionLogic;
  readonly groups?: SearchQuery[];
}
